import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { Actions_CurrentStaffMember } from 'redux/modules/currentStaffMember/Actions'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { I18nModal } from 'utils/i18n/i18nModal'
import { TState } from 'redux/config/root-types'

export const useResetPassword = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(I18nModal.resetPassword)

  const email = useSelector(({ modals }: TState) => modals.data.email)

  const onSubmit = useCallback(() => {
    dispatch(Actions_CurrentStaffMember.saga.restorePasword({ email }))
    dispatch(Actions_Modals.store.hideModal())
  }, [dispatch, email])

  const onCancel = useCallback(() => dispatch(Actions_Modals.store.hideModal()), [dispatch])

  return { t, onSubmit, onCancel }
}
